import { render, staticRenderFns } from "./Pagamentos.vue?vue&type=template&id=75212624&"
import script from "./Pagamentos.vue?vue&type=script&lang=js&"
export * from "./Pagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports